import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetCountryRegionList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/CountryRegion/GetList?` + params, null);

  export const GetCountryRegionListForSelect = (params: any) =>
  GET_ENC(`${BASE_URL}/api/CountryRegion/GetListForSelect?` + params, null);